import React, { useContext, useEffect, useState } from "react";
import Tablecomp from "../comp/Table";
import { contextData } from "../Context";
import { MdDeleteOutline } from "react-icons/md";
import { MdOutlineEdit } from "react-icons/md";
import { toast } from "react-toastify";
import { toastConfirm } from "../utils/toastConfirm";
import axios from "axios";
import "./Blog.scss";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Loader from "../comp/loader/Loader";
const Blog = () => {
  const { blogsData, setBlogsData } = useContext(contextData);

  console.log(blogsData);

  const [language, setLanguage] = useState("");

  const [selectedCategory, setSelectedCategory] = useState("Marathi");

  const [loader, setLoader] = useState(false);

  const deleteBlog = async (id) => {
    try {
      setLoader(true);
      const ok = await toastConfirm(
        "Are you sure you want to delete this blog?"
      );
      if (!ok) return;

      await toast.promise(
        axios.delete(
          `${process.env.REACT_APP_PORT_BACKEND}blog/deleteblog?bId=${id}`
        ),
        {
          pending: "Deleting blog…",
          success: "Blog deleted",
          error: "Could not delete blog",
        }
      );

      setBlogsData((prevData) => prevData.filter((item) => item.id !== id));
      window.location.reload();
    } catch (error) {
      console.log(error);
    } finally {
      setLoader(false);
    }
  };

  const items = [
    {
      label: "English",
      key: "English",
    },
    {
      label: "Marathi",
      key: "Marathi",
    },
  ];

  const handleMenuClick = ({ key }) => {
    setSelectedCategory(key);
  };

  //   useEffect(() => {
  //   if (selectedCategory) {
  //     setBlogsData(selectedCategory);
  //   }
  // }, [selectedCategory]);

  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const id = params.get("id");
  }, [location]);

  const editBlog = (id) => {
    navigate(`/addBlog?id=${id}`);
  };

    const filteredBlogs =
    language === ""
      ? blogsData
      : blogsData?.filter((blog) => blog.language === language);

  const columnConfig = [
    {
      title: "id",
      dataIndex: "bid",
      key: "bid",
    },
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
    },
    {
      title: "Blog Image",
      dataIndex: "featuredImage",
      key: "featuredImage",
      isSearchable: true,
      render: (_, record) => (
        <div class="image" style={{ width: "150px", height: "auto" }}>
          <img
            src={`${record.featuredImage}`}
            alt=""
            style={{ width: "100%", aspectRatio: 1 }}
          />
        </div>
      ),
    },
    {
      title: "Category",
      dataIndex: "category",
      key: "category",
      isSearchable: true,
    },
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      isSearchable: true,
    },
    {
      title: "description",
      dataIndex: "description",
      key: "description",
      render: (_, record) => (
        <div className="action_btn" style={{ display: "flex", gap: "10px" }}>
          <textarea disabled style={{ width: "100%" }}>
            {record.description}
          </textarea>
        </div>
      ),
    },
    {
      title: "action",
      dataIndex: "action",
      key: "action",
      render: (_, record) => (
        <div className="action_btn" style={{ display: "flex", gap: "10px" }}>
          <button className="table_btn" onClick={() => deleteBlog(record.bid)}>
            <MdDeleteOutline />
          </button>
          <button className="table_btn" onClick={() => editBlog(record.bid)}>
            <MdOutlineEdit />
          </button>
        </div>
      ),
    },
  ];

  return (
    <>
      {loader && <Loader />}
      <div class="top_section">
        <div class="btn_list">
          <Link to="/addBlog" class="btn">
            Add Blog
          </Link>
        </div>

        <div className="input-group">
          <label htmlFor="language">Select Language</label>
          <select
            id="category"
            name="category"
            value={language}
            menu={{ items, onClick: handleMenuClick }}
            onChange={(e) => setLanguage(e.target.value)}
          >
            <option value="">Select Category</option>
            <option value="English">English</option>
            <option value="Marathi">Marathi</option>
          </select>
        </div>
      </div>
      <Tablecomp
        columnConfig={columnConfig}
        tableData={blogsData && blogsData && filteredBlogs}
      />
    </>
  );
};

export default Blog;
